import { PayloadAction } from "@reduxjs/toolkit";
import { TIsLoading } from 'common/types/common';

import { IState } from "../types/state";

const action = (state: IState, payloadAction: PayloadAction<TIsLoading>) => {
  state.orderSecondStep.isLoading = payloadAction.payload;
};

export default action;
